import { faCircle } from "@fortawesome/pro-light-svg-icons"
import {
  faCalendarDay,
  faCircleCheck,
  faClockRotateLeft,
  faEnvelopeDot,
  faHourglassStart,
  faWrench
} from "@fortawesome/pro-solid-svg-icons"

export const statusString = (value, t) => {
  switch (value) {
    case 0:
      return t("learning.titles.not_started", "Not Started")
    case 1:
      return t("global.new", "New")
    case 2:
      return t("global.planned", "Planned")
    case 3:
      return t("global.ongoing", "Ongoing")
    case 4:
      return t("global.fixed", "Fixed")
    case 5:
      return t("global.completed", "Completed")
    default:
      return "-"
  }
}

export const prio = (value, t) => {
  switch (value) {
    case 0:
      return t("global.none", "None")
    case 1:
      return t("global.low", "Low")
    case 2:
      return t("global.medium", "Medium")
    case 3:
      return t("global.high", "High")
    case 4:
      return t("vehicleregistry.driving_ban", "Driving Ban")
    default:
      return t("global.none", "None")
  }
}

const issueReportStatusLookup = (theme, t) => ({
  0: {
    icon: faCircle,
    label: t("learning.titles.not_started", "Not Started"),
    color: theme.palette.default[800],
    backgroundColor: theme.palette.foreground.inverted,
    modalLabel: t("learning.titles.not_started", "Not Started")
  },
  1: {
    icon: faEnvelopeDot,
    label: `${t("global.new", "New")}!`,
    color: theme.palette.default[800],
    backgroundColor: theme.palette.foreground.inverted,
    iconColor: theme.palette.warning[500],
    modalLabel: t("global.new", "New")
  },
  2: {
    icon: faClockRotateLeft,
    label: t("global.planned", "Planned"),
    color: theme.palette.sky[700],
    backgroundColor: theme.palette.sky[100],
    modalLabel: t("global.planned", "Planned")
  },
  3: {
    icon: faCalendarDay,
    label: t("global.ongoing", "Ongoing"),
    color: theme.palette.sky[600],
    backgroundColor: theme.palette.sky[100],
    modalLabel: t("global.ongoing", "Ongoing")
  },
  4: {
    icon: faWrench,
    label: t("global.fixed", "Fixed"),
    color: theme.palette.yellow[800],
    backgroundColor: theme.palette.yellow[100],
    modalLabel: t("global.fixed", "Fixed")
  },
  5: {
    icon: faCircleCheck,
    label: t("global.completed", "Completed"),
    color: theme.palette.success[600],
    backgroundColor: theme.palette.green[200],
    modalLabel: t("global.completed", "Completed")
  },
  default: {
    icon: faHourglassStart,
    label: t("global.status_missing", "Status missing"),
    color: theme.palette.default[800],
    backgroundColor: theme.palette.foreground.inverted,
    modalLabel: t("global.status_missing", "Status missing")
  }
})

export const issueReportStatusData = (status, theme, t) => {
  const lookup = issueReportStatusLookup(theme, t)
  return lookup[status] || lookup.default
}
